import { makeStyles } from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import PropTypes from 'prop-types'
import React from 'react'

const useStyles = makeStyles((theme) => ({
	backdrop: {
		zIndex: theme.zIndex.drawer + 1,
		color: '#fff'
	}
}))

export default function ScreenOverlay(props) {
	const classes = useStyles()

	return (
		<Backdrop className={classes.backdrop} open={props.isOpen}>
			<CircularProgress color="inherit" />
		</Backdrop>
	)
}

ScreenOverlay.propTypes = {
	isOpen: PropTypes.bool.isRequired
}
